export default  {
    methods: {
        getUnit(varName,equipmentName){
            for (let point of this.$store.state.pointsListStore.pointsList.points_list){
                if(point.sensor_name===varName&&point.equipment_name===equipmentName){
                    if(point.unit){return point.unit}
                    break
                }
            }
            return null;
        },
    }
};